module.exports = __webpack_public_path__ + "static/media/AgreeFisheries20.6aa6a616.jpg";